export const LINKS: {
  name: string
  url: string
  icon: string
}[] = [
  {
    name: 'Top Headlines',
    url: '/',
    icon: 'shield-virus',
  },
  {
    name: 'Economics',
    url: '/topic/economics',
    icon: 'building',
  },
  {
    name: 'Entertainment',
    url: '/topic/entertainment',
    icon: 'play',
  },
  {
    name: 'World',
    url: '/topic/world',
    icon: 'newspaper',
  },
  {
    name: 'Beauty',
    url: '/topic/beauty',
    icon: 'dumbbell',
  },
  {
    name: 'Science',
    url: '/topic/science',
    icon: 'microscope',
  },
  {
    name: 'Sports',
    url: '/topic/sport',
    icon: 'football-ball',
  },
  {
    name: 'Technology',
    url: '/topic/technology',
    icon: 'microchip',
  },
]
